var map = {
	"./icon_ability_arrow_of_justice.png": 3967,
	"./icon_ability_arrowrain_ice.png": 4387,
	"./icon_ability_arrowrain_royal.png": 1302,
	"./icon_ability_arrowrain_shadow.png": 5989,
	"./icon_ability_bomb_fire.png": 6386,
	"./icon_ability_bomb_ice.png": 6394,
	"./icon_ability_bomb_light.png": 5233,
	"./icon_ability_bomb_royal.png": 8992,
	"./icon_ability_bomb_shadow.png": 6129,
	"./icon_ability_bomb_shock.png": 9444,
	"./icon_ability_fiery_slam.png": 6998,
	"./icon_ability_fire_fan.png": 9289,
	"./icon_ability_frame.png": 297,
	"./icon_ability_healing_totem.png": 7443,
	"./icon_ability_leap_ice.png": 6023,
	"./icon_ability_leap_light.png": 5487,
	"./icon_ability_leap_shadow.png": 2615,
	"./icon_ability_leap_shock.png": 5282,
	"./icon_ability_lightning_totem.png": 6247,
	"./icon_ability_path_of_frost.png": 7766,
	"./icon_ability_royal_rush.png": 4267,
	"./icon_ability_shadow_rush.png": 6416,
	"./icon_ability_shielding_spin.png": 5090,
	"./icon_ability_shock_shot.png": 6310,
	"./icon_ability_torrent_dark.png": 4977,
	"./icon_ability_torrent_fire.png": 2147,
	"./icon_ability_torrent_ice.png": 4732,
	"./icon_ability_torrent_light.png": 1922,
	"./icon_ability_torrent_royal.png": 257,
	"./icon_ability_whirlwind_fire.png": 9514,
	"./icon_ability_whirlwind_royal.png": 8020,
	"./icon_ability_whirlwind_shadow.png": 7021,
	"./icon_ability_whirlwind_shock.png": 1500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9063;